import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { StaffAuthService } from "../../staff/staff-auth.service";

export function staffImpersonationIntercept(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Is a request being made to the client API?
  const url = new URL(request.url);
  if (url.pathname.startsWith("/api/v1/client")){
    const staffAuthService = inject(StaffAuthService);
    if (staffAuthService.GetAuthToken() !== null){
      // A request is being made to a client endpoint
      // Inject staff impersonation, if there is any
      const requestWithStaffImpersonationHeader = request.clone({
        headers: request.headers.append("X-Staff-Impersonation-Token", staffAuthService.GetAuthToken()!),
      });

      return next(requestWithStaffImpersonationHeader);
    }
  }

  return next(request);
}